module.exports = __webpack_public_path__ + "media/audio/shutter-4770b3cf1bfa4a9d845ad36f7b36e9f2.mp3";